import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BulkUpdateCollection {
  id: number
  collectionNo: string
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  type: SystemCode
  title: string
  displayAuthor: string
  holdingBranchCode: SystemCode
  shelfType: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  forwardingBranchCode: SystemCode
  status: SystemCode
  callNumber: string
  displayClass: string
  edition: string
  collectionFlag: CollectionFlag
}

export function BulkUpdateCollectionFromJSON(json: any): BulkUpdateCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : '',
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    type: exists(json, 'type')
      ? SystemCodeFromJSON(json.type)
      : defaultSystemCode(),
    title: exists(json, 'title') ? json.title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    callNumber: exists(json, 'call_number') ? json.call_number : '',
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    edition: exists(json, 'edition') ? json.edition : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection
  }
}
